import styles from "./ChatbotUseCases.module.css";
import {
    ShoppingCart,
    Users,
    Calendar,
    GraduationCap,
    Layers,
    TrendingUp,
} from "lucide-react";

import panelImg from "../../../Images/y4sifey4.png";

const ChatbotUseCases = () => {
    return (
        <>
            {/* ===== TOP SECTION ===== */}
            <section className={styles.section}>
                <h2 className={styles.title}>Built for Real-World Use Cases</h2>

                <div className={styles.grid}>
                    <div className={`${styles.card} ${styles.blue}`}>
                        <ShoppingCart />
                        <span>E-commerce customer support</span>
                    </div>

                    <div className={`${styles.card} ${styles.green}`}>
                        <Users />
                        <span>Lead generation & contact forms</span>
                    </div>

                    <div className={`${styles.card} ${styles.purple}`}>
                        <Calendar />
                        <span>Event registrations</span>
                    </div>

                    <div className={`${styles.card} ${styles.orange}`}>
                        <GraduationCap />
                        <span>Education & student queries</span>
                    </div>

                    <div className={`${styles.card} ${styles.pink}`}>
                        <Layers />
                        <span>SaaS onboarding & product help</span>
                    </div>

                    <div className={`${styles.gradientCard}`}>
                        <TrendingUp />
                        <span>And much more...</span>
                    </div>
                </div>

                <div className={styles.note}>
                    <p>
                        If your website gets traffic,{" "}
                        <strong>ToxboxAI makes it work harder.</strong>
                    </p>
                </div>
            </section>

            {/* ===== BOTTOM HERO ===== */}
            <section className={styles.hero}>
                <div className={styles.heroContent}>
                    <div className={styles.text}>
                        <span className={styles.badge}>✨ No Code Required</span>
                        <h1>
                            Launch a ToxboxAI <br /> Chatbot That Learns <br /> From Your
                            Website
                        </h1>
                        <p>
                            Stop losing leads to slow forms and unanswered questions.
                        </p>

                        <div className={styles.actions}>
                            <button className={styles.primaryBtn}>
                                Try ToxboxAI →
                            </button>
                            <button className={styles.secondaryBtn}>
                                Schedule a Demo
                            </button>
                        </div>
                    </div>

                    <img
                        src={panelImg}
                        alt="Control panel"
                        className={styles.image}
                    />
                </div>
            </section>
        </>
    );
};

export default ChatbotUseCases;